import { api } from '@/api';
import { createAsyncThunk } from '@/store/utils';

export const sendPasswordResetLink = createAsyncThunk<object, string>(
  'reset-password/sendPasswordResetLink',
  async (email) => {
    return await api.customerProfileApi.CustomerProfilePasswordsReset_SendResetLink(
      null,
      {
        email,
      }
    );
  }
);

export const resetPassword = createAsyncThunk<
  object,
  { password: string; passwordResetHash: string }
>('reset-password/resetPassword', async ({ password, passwordResetHash }) => {
  return await api.customerProfileApi.CustomerProfilePasswordsReset_ResetPassword(
    null,
    {
      passwordResetHash,
      password,
    }
  );
});

export const changePassword = createAsyncThunk<
  object,
  { currentPassword: string; newPassword: string; confirmNewPassword: string }
>(
  'reset-password/changePassword',
  async (
    { currentPassword, newPassword, confirmNewPassword },
    { getState }
  ) => {
    const { current } = getState().profile;

    if (!current?.id) {
      throw new Error('No customer profile ID available');
    }

    return await api.customerProfileApi.CustomerProfilePasswordsReset_ChangePassword(
      { customerProfileId: current.id },
      { currentPassword, newPassword, confirmNewPassword }
    );
  }
);
